export default "__VITE_ASSET__DJ81OOoF__"